<div
  [ngClass]="{
    'loading-spinner-wrapper': !inline,
    'loading-spinner-inline': inline
  }"
>
  <div *ngIf="mode == 'thinking'">
    <div class="d-flex justify-content-center align-items-center lead">

    <i class="bx bx-loader bx-spin bx-md"></i> Thinking. I may take some time so please be patient 🙂
    </div>
  </div>

  <ng-container *ngIf="mode == 'loading'">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div>Loading...</div>
    <div class="lds-msg" *ngIf="longWait">
      This is taking longer than it should, sorry. Please wait a little longer
      or
      <a href="#" (click)="refresh()">refresh the page</a>.<br /><br />
      If the problem persists please
      <a href="mailto:support@yoscenario.com">get in touch</a>.
    </div></ng-container
  >
</div>
